module.exports = __webpack_public_path__ + "img/vegetable-olives-190x100.f93ef0e5.jpg";